import BlackBishop from './black_bishop.svg.js';
export { default as BlackBishop } from './black_bishop.svg.js';
import BlackKing from './black_king.svg.js';
export { default as BlackKing } from './black_king.svg.js';
import BlackKnight from './black_knight.svg.js';
export { default as BlackKnight } from './black_knight.svg.js';
import BlackPawn from './black_pawn.svg.js';
export { default as BlackPawn } from './black_pawn.svg.js';
import BlackQueen from './black_queen.svg.js';
export { default as BlackQueen } from './black_queen.svg.js';
import BlackRook from './black_rook.svg.js';
export { default as BlackRook } from './black_rook.svg.js';
import WhiteBishop from './white_bishop.svg.js';
export { default as WhiteBishop } from './white_bishop.svg.js';
import WhiteKing from './white_king.svg.js';
export { default as WhiteKing } from './white_king.svg.js';
import WhiteKnight from './white_knight.svg.js';
export { default as WhiteKnight } from './white_knight.svg.js';
import WhitePawn from './white_pawn.svg.js';
export { default as WhitePawn } from './white_pawn.svg.js';
import WhiteQueen from './white_queen.svg.js';
export { default as WhiteQueen } from './white_queen.svg.js';
import WhiteRook from './white_rook.svg.js';
export { default as WhiteRook } from './white_rook.svg.js';

function getPiece(i){return {bB:BlackBishop,bK:BlackKing,bN:BlackKnight,bP:BlackPawn,bQ:BlackQueen,bR:BlackRook,wB:WhiteBishop,wK:WhiteKing,wN:WhiteKnight,wP:WhitePawn,wQ:WhiteQueen,wR:WhiteRook}[i]}

export { getPiece };
//# sourceMappingURL=index.js.map
